import { BrazeContentCard } from '@/modules/shop/models/braze';
import { Banner } from '@/modules/shop/models/offerModels';

export const brazeToBannerMapper = (card: BrazeContentCard): Banner => ({
  id: card.id,
  name: 'content-card',
  impressionUrl: null,
  mobileLink: card.url,
  mobileImageUrl: card.imageUrl,
  desktopLink: card.url,
  desktopImageUrl: card.imageUrl,
  mobileBrowserLink: card.url,
  mobileBrowserImageUrl: card.imageUrl,
  brazeContentCardInstance: card,
  bannerTCs: null,
  // START Kevel/Ad fields
  adSizeId: 0,
  advertiserId: 0,
  advertiserName: null,
  flightId: 0,
  campaignId: 0,
  rawClickUrl: null,
  keywords: null,
  priorityWeight: 0,
  merchantCommissionString: null,
  merchantDescription: null,
  merchantName: null,
  // END Kevel/Ad fields
});
